/**
 * Shopify Script Optimizer
 * Reduces initial parse/compile time for heavy Shopify-loaded scripts
 * 
 * This script cannot fully control Shopify's content_for_header scripts,
 * but it can optimize how and when they execute
 */

(function() {
  'use strict';
  
  // Override console methods in non-production to reduce logging overhead
  if (window.location.search.indexOf('debug') === -1) {
    var noop = function() {};
    if (window.console) {
      window.console.log = noop;
      window.console.debug = noop;
    }
  }
  
  // Optimize dataLayer for GTM
  window.dataLayer = window.dataLayer || [];
  
  // Create a lightweight GTM stub to prevent errors before GTM loads
  window.gtag = window.gtag || function() {
    dataLayer.push(arguments);
  };
  
  // Optimize Facebook Pixel stub
  window.fbq = window.fbq || function() {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  window.fbq.queue = window.fbq.queue || [];
  
  // Defer heavy feature detection until after page load
  var deferredFeatureDetection = function() {
    // This space can be used for feature detection that doesn't need to run immediately
  };
  
  if (document.readyState === 'complete') {
    setTimeout(deferredFeatureDetection, 1000);
  } else {
    window.addEventListener('load', function() {
      setTimeout(deferredFeatureDetection, 1000);
    });
  }
  
  // Passive event delegation for better scroll performance
  var delegatedEvents = {};
  
  window.optimizedDelegate = function(selector, event, handler) {
    if (!delegatedEvents[event]) {
      delegatedEvents[event] = [];
      document.addEventListener(event, function(e) {
        delegatedEvents[event].forEach(function(config) {
          if (e.target.matches(config.selector) || e.target.closest(config.selector)) {
            config.handler.call(e.target, e);
          }
        });
      }, { passive: true, capture: true });
    }
    
    delegatedEvents[event].push({
      selector: selector,
      handler: handler
    });
  };
  
})();
